export default class InputUpload{
    
    constructor(element) {
        this._wrapper = element;
        this._button = this._wrapper.querySelector('button');
        this._input = this._wrapper.querySelector('input');
        this._baseText = this._wrapper.querySelector('.js-input-upload-basetext');
        this._filename = this._wrapper.querySelector('.js-input-upload-filename');
        this._list = this._wrapper.querySelector('.js-input-upload-list');
        
        this.isMultiple = !!this._list;
        
        this.files = [];
        
        this.bindEvents();
    }
    
    bindEvents(){
        this._wrapper.addEventListener('dragover', (e) => {
            this._wrapper.classList.add('dragover'); 
        });
        this._wrapper.addEventListener('dragleave', (e) => {
            this._wrapper.classList.remove('dragover');
        });
        this._wrapper.addEventListener('drop', (e) => {
            this._wrapper.classList.remove('dragover');
        });
        this._button.addEventListener('click', (e) => {
            e.preventDefault();
            this._input.click();
        });
        
        this._input.addEventListener('change', (e) => {
            if(this.isMultiple){
                Array.from(this._input.files).forEach(file => {
                    this.files.push(file);
                });
                this.updateFileList();
            }
            else {
                this.updateTemplate();
            }
        });
        
    }
    
    updateFileList(){
        this._list.innerHTML = '';
        
        this.files.forEach((item,n) => {
            
            let element = app.createElement(`
            <div class="input-upload__list__item">
                <div class="input-upload__list__item__left">
                    <i class="fa-regular fa-file"></i><span>${item.name}</span>
                </div> 
                <div class="input-upload__list__item__right">
                <button class="js-input-upload-remove"><i class="fa-regular fa-trash"></i><span>Supprimer ce document</span></button>
                </div>
            </div>`);
            element = element[0];
            let _button = element.querySelector('.js-input-upload-remove');
            
            _button.addEventListener('click', (e) => {
               e.preventDefault(); 
               this.removeFile(n);
            });
            
            this._list.appendChild(element);
        });
        
        this.syncWithInput();
        //
        // console.log(this._input.files);
    }
    
    removeFile(index){
        this.files.splice(index, 1);
        this.syncWithInput();
        this.updateFileList();
    }
    
    syncWithInput(){
        const dataTransfer = new DataTransfer();

        this.files.forEach(file => {
            dataTransfer.items.add(file);
        });

        this._input.files = dataTransfer.files;
        let customEvent = new CustomEvent('input-upload:change');
        this._input.dispatchEvent(customEvent);
    }

    updateTemplate(){
        let filename = this._input.value;
        if(filename){
            filename = filename.replace(/^.*\\/, ""); // Remove fakepath
            this._filename.innerText = filename;
            this._baseText.classList.add('d-none');
            this._filename.classList.remove('d-none');
        }
        else{
            this._filename.innerText = '';
            this._baseText.classList.remove('d-none');
            this._filename.classList.add('d-none');
        }

    }
    
    reset(){
        
    }
}